import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { TOMOS, TOMO_FEATURES } from './salesData';
import { HERO_IMAGE_URL } from '../utils/headMeta';
const TOMOS_IMG = HERO_IMAGE_URL;
export function TomosSection() {
  return <section id="tomos" className="bg-ivory py-12 sm:py-16" data-id="element-322" data-mp="1u2wqfa61bi5f">
      <div className="mx-auto max-w-5xl px-5" data-id="element-323" data-mp="1u4hkyzscn13a">
        <div className="text-center" data-id="element-324" data-mp="xdfnh2yfsa7f">
          <SectionTag data-id="element-325" data-mp="xeh2fiikpguf">Qué recibís</SectionTag>
          <h2 className="mt-4 font-display text-[1.45rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.2rem]" data-id="element-326" data-mp="11d7p0vpexg3a">
            El sistema completo en
            <span className="mt-1 block text-gold-deep" data-id="element-327" data-mp="16ff59xh9zibf">5 tomos de implementación</span>
          </h2>
          <p className="mx-auto mt-3 max-w-2xl font-sans text-[0.9rem] leading-relaxed text-charcoal/70 sm:text-base" data-id="element-328" data-mp="1b9swrosth5at">
            Cada tomo resuelve una etapa del método y una fuga concreta del consultorio: qué medir,
            cómo convertir, qué recuperar y cómo hacer rendir cada hora de sillón.
          </p>
        </div>

        <img src={TOMOS_IMG} alt="Los cinco tomos del Método Consultorio Rentable junto a una tablet con los indicadores del consultorio" width={1024} height={1024} loading="lazy" decoding="async" sizes="(max-width: 640px) 82vw, 420px" style={{
        aspectRatio: '1024 / 1024'
      }} className="mx-auto mt-6 block h-auto w-[82%] max-w-[420px] rounded-2xl border border-stone object-cover" data-id="element-329" data-mp="2mm3qaky90vw0" />

        <div className="mt-7 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-330" data-mp="1ywt0tzmcmnx6">
          {TOMOS.map((tomo, i) => <motion.article key={tomo.num} initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.35,
          delay: i * 0.04
        }} className="flex h-full flex-col rounded-2xl border border-stone bg-sand p-5 transition-colors hover:border-gold/60" data-id="element-331" data-mp="1tyhq7mo8c9dw" data-mpi={i}>
              <div className="flex items-center gap-2.5" data-id="element-332" data-mp="1fcam6f8tg6ed">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-charcoal font-sans text-[0.72rem] font-bold tabular-nums text-ivory" data-id="element-333" data-mp="11bhoxmr4qx7k">
                  {tomo.num}
                </span>
                <p className="font-sans text-[0.58rem] font-bold uppercase tracking-editorial text-gold-deep" data-id="element-334" data-mp="1t25oiud5nuj4">
                  Tomo {Number(tomo.num)} · {tomo.stage}
                </p>
              </div>

              <h3 className="mt-3 font-display text-[1.05rem] font-bold uppercase leading-tight text-charcoal" data-id="element-335" data-mp="1kavkua8f6i0p">
                {tomo.title}
              </h3>
              <p className="mt-1.5 font-sans text-[0.82rem] leading-relaxed text-charcoal/70" data-id="element-336" data-mp="1o9kxg0lmvvja">
                {tomo.outcome}
              </p>

              <ul className="mt-3.5 space-y-1.5 border-t border-stone pt-3.5" data-id="element-337" data-mp="2gsi32o2wopio">
                {tomo.points.map(point => <li key={point} className="flex items-start gap-2" data-id="element-338" data-mp="5bopsn9tbitm">
                    <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden data-id="element-339" data-mp="ey8jwm9uh6m" />
                    <span className="font-sans text-[0.78rem] leading-snug text-charcoal/75" data-id="element-340" data-mp="f3cbs8nlo7np">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </motion.article>)}
        </div>

        <div className="mt-6 rounded-2xl border border-gold/40 bg-gold-soft/40 px-5 py-5 text-center" data-id="element-341" data-mp="3ilmaxepxsq8l">
          <p className="mx-auto max-w-2xl font-sans text-[0.9rem] font-medium leading-relaxed text-charcoal sm:text-base" data-id="element-342" data-mp="3shz7ckcv9i71">
            No son cinco ebooks sueltos. Es una secuencia de implementación: cada tomo se apoya en el
            anterior y deja el consultorio funcionando un poco más rentable que antes.
          </p>
        </div>

        <div id="incluye" className="mt-6 rounded-2xl border border-stone bg-sand p-5 sm:p-6" data-id="element-343" data-mp="12rlsiw5yi57z">
          <h3 className="text-center font-display text-base font-bold uppercase text-charcoal sm:text-lg" data-id="element-344" data-mp="38hz7lauta916">
            Cada tomo incluye
          </h3>
          <ul className="mt-4 grid gap-x-6 gap-y-1.5 sm:grid-cols-2" data-id="element-345" data-mp="3dhvaf6rrvuf5">
            {TOMO_FEATURES.map(f => <li key={f} className="flex items-start gap-2" data-id="element-346" data-mp="3mgp0eeallmjq">
                <CheckIcon className="mt-[3px] h-3.5 w-3.5 shrink-0 text-gold" aria-hidden data-id="element-347" data-mp="3mi06wlvfh8ej" />
                <span className="font-sans text-[0.82rem] leading-snug text-charcoal/75" data-id="element-348" data-mp="3rfa3clh8ikbv">{f}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}